import type { FaireProductEntity } from "../../entity_types/product";

export const p_tvs6hkzhf6: FaireProductEntity = {
  token: "p_tvs6hkzhf6",
  type: "product",
  name: "NEW!! Sunshine Whisper - Blush and Lip Shimmer Set",
  brandToken: "b_1wdyenfg",
  brandName: "Klee Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/dcfb5db31117146472df36201cfffcbb9128d676994e29e587bab9641ef9455b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d7f59ca118041b15abe801b52aa6bc329da5eff587c3629da40130c7319799e6.jpeg",
    "https://cdn.faire.com/fastly/1df62f2657a5dc8db06b43ebca0c4427641c48b408050138a6468aec6bf39e0e.jpeg",
    "https://cdn.faire.com/fastly/4accb5c4f362f71370ed82aaf49ee7ef2d9d8558dcf00057cb1edec205f4c0d9.jpeg",
    "https://cdn.faire.com/fastly/a6be2a35e90624ccf840d53b55c3bf88beab276df8dd643ee42ce28ce32e0639.jpeg",
    "https://cdn.faire.com/fastly/81e08ecaf507128f45e810d03d841c029252487ee9c1b564cbee3f1f8def34d2.png",
    "https://cdn.faire.com/fastly/9f784b97a5c10573e259595efa278783186e7f991492a9f19320c5427945d035.png",
    "https://cdn.faire.com/fastly/d02bb6cf4767139455100d1c39f1955b79c87e3ac40649c60cf7a293d4d97d92.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "The colors. The movement. The magic of sunlight bouncing off a spinning pinwheel, scattering pieces of colorful bliss. At Klee Naturals, our goal is to capture that same wonder by offering our little ones their very own makeup, crafted to be as safe and natural as it is enchanting.\n\nAfter all, why ruin delicate young skin with harsh chemicals?\n\nThe Sunshine Whisper set includes the all-time bestselling Newport Whisper mineral blush and Strawberry Kiss lip shimmer.\n \nKlee Naturals makeup is formulated with NO talc, NO parabens, NO synthetic dyes and NO petrochemical binders. Gentle and non-toxic. No animal testing and gluten-free.  \n\nMade in USA.",
  tags: [],
  msrpDollars: 16.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:25.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
